export default __webpack_public_path__ + "static/hkgrotesk-boldlegacy-webfont-def5f30d9319e9fdaf699b39abd32930.woff2";